const {
    BASE_DOMAIN,
    REACT_APP_CURRENT_APP,
    REACT_APP_AUTH_URL,
    REACT_APP_BACKUPS_URL,
    REACT_APP_CONFIGS_URL,
    REACT_APP_CCX_URL,
    REACT_APP_DEFAULT_URL,
    REACT_APP_AGENT_INSTALL_URL,
    REACT_APP_AGENT_AUTH_API_URL,
    REACT_APP_PROFILE_URL,
    REACT_APP_USER_AUTH_SERVICE_URL,
    REACT_APP_USER_PROFILE_SERVICE_URL,
    REACT_APP_AGENT_SERVICE_URL,
    REACT_APP_BACKUPS_SERVICE_URL,
    REACT_APP_CONTENT_SERVICE_URL,
    REACT_APP_BILLING_SERVICE_URL,
    REACT_APP_AGENT_INSTALL_SCRIPT_NAME = process.env
        .REACT_APP_AGENT_INSTALL_SCRIPT_NAME,
} = window.FEAS_ENV;

const productionDomain = 's9s.io';
const backupsAppProductionDomain = 'backup.ninja';
const baseDomain = BASE_DOMAIN || productionDomain;

export const currentApp =
    process.env.REACT_APP_CURRENT_APP || REACT_APP_CURRENT_APP || 'bn';

export const isProduction = baseDomain === productionDomain;

const appUrl = isProduction
    ? `https://app.${backupsAppProductionDomain}`
    : `https://backups.${baseDomain}`;

export const authUrl =
    process.env.REACT_APP_AUTH_URL ||
    REACT_APP_AUTH_URL ||
    `https://auth.${baseDomain}`;

export const backupsUrl =
    process.env.REACT_APP_BACKUPS_URL || REACT_APP_BACKUPS_URL || appUrl;

export const configsUrl =
    process.env.REACT_APP_CONFIGS_URL ||
    REACT_APP_CONFIGS_URL ||
    `https://configs.${baseDomain}`;

export const ccxUrl =
    process.env.REACT_APP_CCX_URL ||
    REACT_APP_CCX_URL ||
    `https://ccx.${baseDomain}`;

export const defaultUrl =
    process.env.REACT_APP_DEFAULT_URL || REACT_APP_DEFAULT_URL || backupsUrl;

export const agentInstallUrl =
    process.env.REACT_APP_AGENT_INSTALL_URL ||
    REACT_APP_AGENT_INSTALL_URL ||
    `${backupsUrl}/servers/install`;

export const agentAuthApiUrl =
    process.env.REACT_APP_AGENT_AUTH_API_URL ||
    REACT_APP_AGENT_AUTH_API_URL ||
    (isProduction ? '' : `agent-auth-api.${baseDomain}:443`);

export const profileUrl =
    process.env.REACT_APP_PROFILE_URL ||
    REACT_APP_PROFILE_URL ||
    `https://profile.${baseDomain}`;

export const userServiceUrl =
    process.env.REACT_APP_USER_AUTH_SERVICE_URL ||
    REACT_APP_USER_AUTH_SERVICE_URL ||
    `https://auth-api.${baseDomain}`;

export const userProfileServiceUrl =
    process.env.REACT_APP_USER_PROFILE_SERVICE_URL ||
    REACT_APP_USER_PROFILE_SERVICE_URL ||
    `https://profile-api.${baseDomain}`;

export const agentServiceUrl =
    process.env.REACT_APP_AGENT_SERVICE_URL ||
    REACT_APP_AGENT_SERVICE_URL ||
    `https://agents-api.${baseDomain}`;

export const backupServiceUrl =
    process.env.REACT_APP_BACKUPS_SERVICE_URL ||
    REACT_APP_BACKUPS_SERVICE_URL ||
    `https://backups-api.${baseDomain}`;

export const contentApiUrl =
    process.env.REACT_APP_CONTENT_SERVICE_URL ||
    REACT_APP_CONTENT_SERVICE_URL ||
    `https://content-api.${baseDomain}`;
export const billingServiceUrl =
    process.env.REACT_APP_BILLING_SERVICE_URL ||
    REACT_APP_BILLING_SERVICE_URL ||
    `https://billing-api.${baseDomain}`;

export const installScriptName =
    REACT_APP_AGENT_INSTALL_SCRIPT_NAME || 'linux.sh';

export const cdnUrl = 'https://st.s9s.io';
